import React from 'react'

import styles from './PatientHistoryEmptyState.module.scss'

interface PatientHistoryEmptyStateProps {
  message: string
}

const PatientHistoryEmptyState: React.FC<PatientHistoryEmptyStateProps> = ({
  message,
}) => <div className={styles.container}>{message}</div>

export default PatientHistoryEmptyState
